export default "__VITE_ASSET__BX4aW85B__"